import { render } from "./ThirdPart.vue?vue&type=template&id=1c25563e&scoped=true"
import script from "./ThirdPart.vue?vue&type=script&lang=js"
export * from "./ThirdPart.vue?vue&type=script&lang=js"

import "./ThirdPart.vue?vue&type=style&index=0&id=1c25563e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c25563e"]])

export default __exports__